module.exports = __webpack_public_path__ + "static/media/wrg-logo.3a0fcf17.png";